module.exports = __webpack_public_path__ + "img/symbol_5.7856c3dd.png";